import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/TeamPage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const routerProp = router["team"];
  const titleKey = "page.team.banner.title";

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "TeamPageBannerSection", props: { className: "pb-5" } },
        { component: "TeamPageFeedSection", props: { className: "pb-md-5 mb-md-5" } },
      ],
    },
  };
}
